export class Score {
    scaled;
    raw;
    min;
    max;
    constructor(cfg = {}) {
        this.init(cfg);
    }
    init(cfg = {}) {
        const { scaled, raw, min, max } = cfg;
        this.scaled = scaled;
        this.raw = raw;
        this.min = min;
        this.max = max;
    }
    asVersion(version = '1.0.6') {
        const { scaled, raw, min, max } = this;
        const result = {
            scaled: scaled || 0,
            raw,
            min,
            max
        };
        return result;
    }
    static fromJSON(scoreJSON) {
        const _score = JSON.parse(scoreJSON);
        return new Score(_score);
    }
}
